// extracted by mini-css-extract-plugin
export default {"spin":"LoadingComponent_spin__P+FAx"};